import { Directive, computed, contentChildren } from '@angular/core';
import { RadioButtonComponent } from '../../components/inputs/radio-button/radio-button.component';
import { DatePickerComponent } from '../../components/inputs/date-picker/date-picker.component';
import { CheckboxButtonComponent } from '../../components/inputs/checkbox-button/checkbox-button.component';
import { InputTextComponent } from '../../components/inputs/input-text/input-text.component';
import { TextAreaComponent } from '../../components/inputs/text-area/text-area.component';
import { CheckboxYesNoComponent } from '../../components/inputs/checkbox-button/checkbox-yes-no/checkbox-yes-no.component';
import { RadioButtonGroupComponent } from '../../components/inputs/radio-button-group/radio-button-group.component';

@Directive({
  selector: '[_appSelectAllFormFields]',
  standalone: true
})
export abstract class SelectAllFormFieldsDirective {

  radios = contentChildren(RadioButtonComponent , {descendants: true})
  radiosG = contentChildren(RadioButtonGroupComponent , {descendants: true})
  date = contentChildren(DatePickerComponent , {descendants: true})
  singleCheck = contentChildren(CheckboxButtonComponent , {descendants: true})
  yesNoCheck = contentChildren(CheckboxYesNoComponent , {descendants: true})
  textInputs = contentChildren(InputTextComponent , {descendants: true})
  textArea = contentChildren(TextAreaComponent , {descendants: true })

  allChildrenFields = computed( () => [
    ...this.radios() , ...this.radiosG(), ...this.date() , ...this.singleCheck(), ...this.textInputs() , ...this.textArea(), ...this.yesNoCheck()
  ])


}
